/* eslint-disable react/no-unused-prop-types */
import type { FilterableIndicator } from "components/screener/v2/ScreenerFilterableIndicators";
import type { FilterCondition } from "components/screener/v2/filters/types";
import classNames from "components/ui/classNames";
import { CheckIcon, XIcon } from "lucide-react";
import { FormattedMessage, useIntl } from "react-intl";

interface FilterRuleDefinitionHeaderProps {
  indicator: FilterableIndicator;
  appliedCondition?: FilterCondition | null;
  onOpenChange: (isOpen: boolean) => void;
  onRemoveFilter: () => void;
  onConfirmFilter?: () => void;
}
export function FilterRuleDefinitionHeader({
  indicator,
  onOpenChange,
  onRemoveFilter,
  onConfirmFilter,
}: FilterRuleDefinitionHeaderProps) {
  const intl = useIntl();
  return (
    <div
      className={classNames("relative flex items-center gap-x-2 px-1", {
        "items-start": indicator.abbreviation.length >= 20,
      })}
    >
      <button
        type="button"
        className={classNames(
          "flex size-8 items-center justify-center rounded-full bg-slate-100 p-1 outline-none",
          "hover:bg-slate-200",
          "focus:outline-none",
          "dark:bg-slate-950",
          "group",
        )}
        onClick={() => onOpenChange(false)}
      >
        <XIcon
          absoluteStrokeWidth={true}
          strokeWidth={3}
          className="size-5 stroke-slate-600 group-hover:stroke-slate-500 dark:stroke-slate-500 dark:group-hover:stroke-slate-300"
        />
      </button>
      <div className="flex flex-col justify-start gap-y-0">
        <h3 className="line-clamp-2 max-w-60 break-words text-base font-bold leading-5 text-slate-800 dark:text-slate-200">
          {indicator.abbreviation}
        </h3>
        <div className="flex">
          <button
            type="button"
            className="m-0 p-0 text-xs font-bold tracking-wide text-rose-600 outline-none hover:underline dark:text-rose-300"
            onClick={onRemoveFilter}
          >
            <FormattedMessage defaultMessage="Remover Filtro" id="LM7Ra3" />
          </button>
        </div>
      </div>
      {onConfirmFilter && (
        <button
          type="button"
          title={intl.formatMessage({ defaultMessage: "Confirmar Filtro", id: "/KNlMk" })}
          className={classNames(
            "ml-auto flex items-center justify-center rounded-full p-1 outline-none",
            "bg-viridian-100 hover:bg-viridian-200/80",
            "dark:bg-lime-600/20",
            "dark:hover:bg-lime-600/40",
            "group",
          )}
          onClick={onConfirmFilter}
        >
          <CheckIcon
            absoluteStrokeWidth={true}
            strokeWidth={2.5}
            className={classNames(
              "stroke-viridian-600",
              "group-hover:stroke-viridian-700",
              "dark:stroke-lime-500 dark:group-hover:stroke-lime-500",
              "size-6",
            )}
          />
        </button>
      )}
    </div>
  );
}
